module.exports = __webpack_public_path__ + "img/axiom_qr_code.781a1abb.png";